// extracted by mini-css-extract-plugin
export default {"zoomControls":"Vta-z","zoomControlButton":"Wta-z","zoomBanner":"Xta-z","bannerButton":"Yta-z","imageButton":"Zta-z"};